<template>
  <div class="w-full h-full">
    <el-table
      ref="tableRef"
      height="calc(100% - 50px)"
      class="mt-10px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column width="50" :label="`${$t('序号')}`" type="index"></el-table-column>
      <el-table-column :label="`${$t('传感器编码')}`" show-overflow-tooltip prop="boxIdentifier">
      </el-table-column>
      <el-table-column :label="`${$t('传感器类型')}`" show-overflow-tooltip prop="sensorTypeName">
      </el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="50" v-if="false">
        <template #default="{ row }">
          <div class="w-15px cursor-pointer text-[#00BCC8]" @click="lookDetail(row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getTableList()"
      :pager-count="5"
    >
    </el-pagination>
  </div>
</template>

<script>
import { WizboxListingApi } from '@wiz-api/data-box'

const wizboxListingApi = new WizboxListingApi()

export default {
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {},
  data() {
    return {
      keyWords: '',
      tableData: [],
      page: {
        total: 0,
        pageSize: 15,
        pageNo: 1,
      },
      showDetailDig: false,
    }
  },
  methods: {
    async getTableList() {
      const [err, res] = await wizboxListingApi.findAllUsingGET1({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
      })
      if (!err) {
        this.tableData = res.data
        this.page.total = res.page.pageTotal
      }
    },
    lookDetail() {
      this.showDetailDig = true
      this.drawMarker()
    },
    closeDig() {
      this.showDetailDig = false
    },
  },
  mounted() {},
  created() {
    this.getTableList()
  },
  beforeDestroy() {},
}
</script>

<style>
</style>
